import styled from 'styled-components'

export const AnimationContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: 8px;
  margin-bottom: 24px;
`
